//@flow

// Vendors
import React from 'react';
import { useSelector } from 'react-redux';

// Components
import { Loading } from '../../../components';

// Helpers
import { selectAgencyLink } from '../../../reducers/agency/agencySelectors';
import useRedirect from '../../../hooks/useRedirect';

// PRJ1417943 - Integration Accelerator - Dynamically load all agency AlreadyLinkedSummary components
const summaryContext = require.context(
  '../../../agencies',
  true,
  /link-service\/AlreadyLinkedSummary\.js$/
);
const agencySummaryComponents = {};
summaryContext.keys().forEach(key => {
  // PRJ1417943 - Integration Accelerator - Extract agency slug from path, e.g. './DPS/link-service/AlreadyLinkedSummary.js' => 'dps'
  const match = key.match(/\.\/(.*?)\/link-service\/AlreadyLinkedSummary\.js$/);
  if (match) {
    const slug = match[1].toLowerCase();
    agencySummaryComponents[slug] = summaryContext(key).default;
  }
});

const LinkServiceAlreadyLinked = () => {
  const link = useSelector(selectAgencyLink);
  useRedirect(!link || !link.linkData, '/link');
  if (!link) return <Loading />;

  const { agency } = link;
  const AgencySummary = agencySummaryComponents[agency.agencySlug];
  if (AgencySummary) {
    return <AgencySummary {...link.linkData} />;
  }
  return <></>;
};

export default LinkServiceAlreadyLinked;
